"use client";

import { ReactNode } from "react";
import { PassType } from "@/types/pass";
import { useEffectivePass } from "@/hooks/useEffectivePass";

interface PassStatusWrapperProps {
  children: ReactNode;
}

// starter 이상 이용권인지 확인
const STARTER_OR_ABOVE: PassType[] = ['starter', 'premium', 'complete', 'intelligence'];

/**
 * starter 이상 이용권 사용자에게만 children 을 노출하는 게이트.
 *
 * 이용권 상태는 JWT publicMetadata 를 읽는 useEffectivePass() 로 직접 판정한다 (JCG-2017).
 * 기존 /api/pass/status fetch + sessionStorage 캐시는 제거됨 — JWT 토큰이 모든 요청에
 * 실려 다니므로 추가 fetch 0회로 effective passType/isActive 를 즉시 얻는다.
 */
export default function PassStatusWrapper({ children }: PassStatusWrapperProps) {
  const { isLoaded, isActive, passType } = useEffectivePass();

  // Clerk 사용자 로드 전에는 렌더링하지 않음 (미로그인 시에도 passType='free'로 게이트)
  if (!isLoaded) {
    return null;
  }

  const hasAccess = isActive && STARTER_OR_ABOVE.includes(passType);
  if (!hasAccess) {
    return null;
  }

  return <>{children}</>;
}
